import { DataFetchingClient, DataFetchingClientProvider, useDataFetchingClient } from 'data-fetching-client';
import useFetchFintechOutagesStatus from '../hooks/useFetchFintechOutagesStatus.hook';
import FintechOutageBanner from './FintechOutageBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const fallbackDataFetchingClient = new DataFetchingClient();
const FintechOutageBannerWithFetchInner = ({
  actionContext,
  hubId = null,
  onError
}) => {
  const outagesStatus = useFetchFintechOutagesStatus(hubId, onError);
  return /*#__PURE__*/_jsx(FintechOutageBanner, {
    availabilityStatus: outagesStatus,
    actionContext: actionContext
  });
};
const FintechOutageBannerWithFetch = props => {
  var _useDataFetchingClien;
  const client = (_useDataFetchingClien = useDataFetchingClient(false)) !== null && _useDataFetchingClien !== void 0 ? _useDataFetchingClien : fallbackDataFetchingClient;
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: client,
    children: /*#__PURE__*/_jsx(FintechOutageBannerWithFetchInner, Object.assign({}, props))
  });
};
export default FintechOutageBannerWithFetch;